import { Exclude, Expose } from '@nts/std/serialization';
import { ServiceRequest } from './service-request';

@Exclude()
export class GenericArrayServiceRequest<TRequestData> extends ServiceRequest {

    @Expose()
    requestData: TRequestData[];
}
